<template>
	<div class="sale-order-switch">
		<!-- category=1：复用客户查询内容与接口，标题仍为订单记录 -->
		<order-details1 v-if="categoryReady && isCategoryOne" :as-order-record="true" />
		<div
			v-else-if="categoryReady"
			class="sale-order-page"
			v-loading="pageLoading"
			:element-loading-text="$t('sale.common.loading')"
		>
		<div class="sale-page-header">
			<div class="sale-page-header__top">
				<div class="sale-page-header__left">
					<h2 class="sale-page-title">{{ $t('sale.order.title') }}</h2>
					<span class="sale-page-desc">{{ $t('sale.order.desc') }}</span>
				</div>
			</div>
			<div class="sale-query-bar">
				<div class="sale-query-item sale-query-item--date">
					<label>{{ $t('sale.order.saleTime') }}</label>
					<el-date-picker
						v-model="formInline.time"
						type="daterange"
						size="small"
						value-format="timestamp"
						:range-separator="$t('sale.common.to')"
						:start-placeholder="$t('sale.common.startDate')"
						:end-placeholder="$t('sale.common.endDate')">
					</el-date-picker>
				</div>
				<div class="sale-query-item">
					<label>{{ $t('sale.order.payType') }}</label>
					<el-select v-model="formInline.payType" clearable :placeholder="$t('sale.order.payType')" size="small">
						<el-option v-for="item in optionsPayType" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</div>
				<div class="sale-page-header__actions">
					<el-button size="small" type="primary" @click="getData()">{{ $t('sale.order.search') }}</el-button>
					<el-button size="small" plain type="primary" @click="exportsee">{{ $t('sale.order.export') }}</el-button>
				</div>
			</div>
		</div>

		<section class="sale-panel sale-panel--table">
			<div class="sale-panel__head">
				<span>{{ $t('sale.order.list') }}</span>
				<span class="sale-panel__count">{{ $t('sale.order.total', { n: allpage }) }}</span>
			</div>
			<div class="table">
				<el-table :data="tableData" style="width: 100%" height="100%" :empty-text="$t('sale.common.empty')">
					<el-table-column prop="bill.id" :label="$t('col.id')" width="80px"></el-table-column>
					<el-table-column :label="$t('col.createTime')" width="180px">
						<template slot-scope="scope">{{ setTime(scope.row.bill.createAt) }}</template>
					</el-table-column>
					<el-table-column prop="detailsname" :label="$t('col.name')" width="200"></el-table-column>
					<el-table-column :label="$t('col.product')" min-width="150">
						<template slot-scope="scope">{{ $tCommodityName(scope.row.product && scope.row.product.name) }}</template>
					</el-table-column>
					<el-table-column prop="detailCount" :label="$t('col.qty')" align="center" width="100" class-name="sale-qty-col" label-class-name="sale-qty-col"></el-table-column>
					<el-table-column :label="$t('col.orderNo')" align="center" min-width="160">
						<template slot-scope="scope">
							<span>{{scope.row.bill.billingNo}}</span>
						</template>
					</el-table-column>
					<el-table-column :label="$t('col.amount')" width="140">
						<template slot-scope="scope">
							<span class="yellow">￥{{scope.row.bill.realAmount/100}}{{ $t('sale.common.yuan') }}</span>
						</template>
					</el-table-column>
					<el-table-column :label="$t('col.payMethod')" width="140">
						<template slot-scope="scope">
							<span v-if="scope.row.channel == '' || scope.row.channel == null || scope.row.channel == undefined">{{payTypeFun(scope.row.bill.payType,3)}}</span>
							<span v-else>
								<span v-if="scope.row.channel.category">{{payTypeFun(scope.row.bill.payType,scope.row.channel.category)}}</span>
								<span v-else>{{payTypeFun(scope.row.bill.payType,3)}}</span>
							</span>
						</template>
					</el-table-column>
					<el-table-column :label="$t('col.status')" width="140">
						<template slot-scope="scope">
							<span class="sale-status">{{ billingState[scope.row.bill.billingState] }}</span>
						</template>
					</el-table-column>
					<el-table-column :label="$t('col.op')" align="center" width="180" class-name="sale-op-col">
						<template slot-scope="scope">
							<router-link class="blue" :to="{path:'/sale/order/orderDetails',query:{id:scope.row.bill.id}}">{{$t('op.detail')}}</router-link>
							<span v-if="scope.row.bill.orderType != 3" class="sale-op-gap">
								<el-button v-if="scope.row.bill.billingState == 0 || scope.row.bill.billingState == 4" type="text" disabled>{{$t('op.refund')}}</el-button>
								<el-button v-else type="text" @click="centerDialogVisible=true;exitData=scope.row">{{$t('op.refund')}}</el-button>
								<!-- <el-button type="text" @click="downPdf(scope.row.bill.id)">凭证下载</el-button> -->
							</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="fenye">
				<pages class="pagination" :allpage="allpage" :changePage="changePage"></pages>
			</div>
		</section>
		<el-dialog
			:title="$t('dialog.tip')"
			:visible.sync="centerDialogVisible"
			width="420px"
			center
			custom-class="sale-dialog sale-dialog--tip"
		>
			<div class="sale-dialog-tip sale-dialog-tip--warn">{{$t('dialog.confirmRefund')}}</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false">{{$t('op.cancel')}}</el-button>
				<el-button type="primary" @click="sureExit">{{$t('op.confirm')}}</el-button>
			</span>
		</el-dialog>
		<el-dialog
			:title="$t('dialog.friendTip')"
			:visible.sync="centerDialogVisible1"
			width="480px"
			center
			custom-class="sale-dialog sale-dialog--tip"
		>
			<div class="sale-dialog-tip">{{ $t('dialog.refundSuccess') }}</div>
			<template v-if="exitData && exitData.invoices && exitData.invoices.length">
				<refundDialog
					v-for="(item, index) in exitData.invoices"
					:key="index"
					:fpdm="item.fpdm"
					:fphm="item.fphm"
					:prodectName="exitData.product && exitData.product.name"
				/>
			</template>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="centerDialogVisible1 = false">{{$t('op.confirm')}}</el-button>
			</span>
		</el-dialog>
		</div>
		<div v-else class="sale-order-page" v-loading="true" :element-loading-text="$t('sale.common.loading')"></div>
	</div>
</template>

<script>
	import { listDd, refund, downloadPdf, getInfo } from '@/axios/api.js'
	import common from '@/assets/common.js'
	import Clipboard from 'clipboard';
	import { Loading } from 'element-ui';
	import axios from 'axios'
    import refundDialog from '@/components/refundDialog'
	import OrderDetails1 from '@/views/sale/Orderdetails1.vue'
	export default {
		data() {
			return {
				/** getInfo 是否已返回 */
				categoryReady: false,
				/** getInfo.obj.category === 1 */
				isCategoryOne: false,
				searchText: '',
				tableData: [],
				tableData4: [],
				formInline: {
					time: null,
					payType:''
				},
            	allpage: 0, //数据总数
				pageLoading: false,
				centerDialogVisible: false,
				centerDialogVisible1:false,
				exitData: {},
				}
		},
     
    computed: {
			optionsPayType() {
				void this.appLocale
				return [
					{ value: '1', label: this.$t('pay.alipay') },
					{ value: '2', label: this.$t('pay.wechat') },
					{ value: '3', label: this.$t('pay.offline') },
					{ value: '11', label: this.$t('pay.prestore') },
					{ value: '999', label: this.$t('pay.online') }
				]
			},
			billingState() {
				void this.appLocale
				return [
					this.$t('billing.0'),
					this.$t('billing.1'),
					this.$t('billing.2'),
					this.$t('billing.3'),
					this.$t('billing.4'),
					this.$t('billing.5')
				]
			}
		},
    components:{
      refundDialog,
      OrderDetails1
    },
		methods: {
            /**
             * 付款方式展示（英文走对照表）
             * @param {number|string} str 支付类型
             * @param {number|string} channel 渠道类型
             * @returns {string}
             */
            payTypeFun(str,channel){
				var zh = common.payType(str,channel)
				if (this.appLocale !== 'en') return zh
				var map = {
					'支付宝': this.$t('pay.alipay'),
					'微信': this.$t('pay.wechat'),
					'线下': this.$t('pay.offline'),
					'转账': this.$t('pay.transfer'),
					'预存支付': this.$t('pay.prestore'),
					'赠送': this.$t('pay.gift'),
					'实时分账': this.$t('pay.split'),
					'在线支付': this.$t('pay.online')
				}
				return map[zh] || zh
			},
			changePage(start,count){
				this.getData(start,count)
			},
			setTime(str) {
				return common.time(str)
			},
			/**
			 * 根据 getInfo.category 决定展示订单列表或客户查询内容
			 */
			resolveCategory() {
				getInfo()
					.then((res) => {
						var category = 0
						if (res.data && res.data.code == 0 && res.data.obj) {
							category = res.data.obj.category
							localStorage.setItem('category', category)
						} else {
							category = window.localStorage.getItem('category') || 0
						}
						this.isCategoryOne = String(category) === '1'
						this.categoryReady = true
						if (!this.isCategoryOne) {
							this.getData()
						}
					})
					.catch(() => {
						var category = window.localStorage.getItem('category') || 0
						this.isCategoryOne = String(category) === '1'
						this.categoryReady = true
						if (!this.isCategoryOne) {
							this.getData()
						}
					})
			},
			getData(start,count) {
				var start=start || 0;//当前页
				var count=count || 10;//每页多少个
				var startts = '';
				var endts = '';
				if (this.formInline.time && this.formInline.time.length === 2) {
					startts = this.formInline.time[0];
					if(this.formInline.time[0] == this.formInline.time[1]) {
						endts = this.formInline.time[1] + 86399000;
					} else {
						endts = this.formInline.time[1];
					}
				}
				var data = {
					start,
					count,
					startts: startts,
					endts: endts,
					payType: this.formInline.payType
				}
				this.pageLoading = true;
				listDd(data).then(res => {
                    this.tableData = res.data.obj;       
					for( var i = 0; i<this.tableData.length; i++) {
						if(this.tableData[i].product.productGroup == 'G67') {
							this.tableData[i].detailsname = this.tableData[i].details[0].name
						}else {
							var str = ''
						for(var j = 0; j<this.tableData[i].details.length; j++) {
							str += this.tableData[i].details[j].name + ','
						}
						var str1 = str.substr(0, str.length - 1);
						this.tableData[i].detailsname = str1
					    }
                    }
                     this.allpage = res.data.total;
					})
					.catch(err => {
						console.log(err)
					})
					.finally(() => {
						this.pageLoading = false;
					})
			},
			exportsee() {
				var token=JSON.parse(window.localStorage.getItem("token")).data.obj.token
				var startts = '';
				var endts = '';
				if (this.formInline.time && this.formInline.time.length === 2) {
					startts = this.formInline.time[0];
					if(this.formInline.time[0] == this.formInline.time[1]) {
						endts = this.formInline.time[1] + 86399000;
					} else {
						endts = this.formInline.time[1];
					}
				}
				var params = `token=${token}`;
				if (startts) {
					params += `&startts=${startts}&endts=${endts}`;
				}
				if (this.formInline.payType) {
					params += `&payType=${this.formInline.payType}`;
				}
				window.location =`${SEVERS}rescue_sale/order/exportOrderList?${params}`
			},
			sureExit() { //退单
				var data = {
					billId: this.exitData.bill.id
				}
				refund(data)
					.then(res => {
						if (res.data.code == 0) {
							this.$message({
								message: this.$t('dialog.refundSuccess'),
								type: 'success'
							})
							this.getData()
							this.centerDialogVisible1 = true
						} else if (res.data.code == 105009) {
							this.$message.error(this.$t('dialog.refundActivatedFail'))
						} else if (res.data.code == 105014) {
							this.$message.error(this.$t('dialog.refundFail'))
						} else if (res.data.code == 105015) {
							this.$message.error(this.$t('dialog.refundPartialFail'))
						} else if (res.data.code == 105042) {
							this.$message.error(this.$t('dialog.refundPartialFail'))
						} else {
							this.$message.error(this.$tApiMsg(res.data.msg, res.data.code) || this.$t('dialog.refundFail'))
						}
						this.centerDialogVisible = false;
					})
					.catch(err => {
						console.log(err)
					})
			},
			changePage(size,each){
				this.getData(size,each)
			},
      downPdf(id){
        var loadingInstance = Loading.service({ fullscreen: true })
        const httpAxios = axios.create();//创建实例
        httpAxios.defaults.timeout = 1000 * 60 * 2;
        httpAxios.get(API_BASE_EWM + 'rescue_sale/sale/download_pdf',{
				params:{
					token:JSON.parse(window.localStorage.getItem("token")).data.obj.token,
					id
				}
				})
				.then(res => {
				console.log(res);
				if(res.data.code == 0){
					loadingInstance.close();
					window.location=res.data.obj
				}
				})
				.catch(err => {
				console.log(err);
				loadingInstance.close();
				})
			}
		},
    created() {

    },
		mounted() {
			this.resolveCategory()
		}
	}
</script>
<style>
	.has-gutter th {
		background-color: #f5f7fb;
	}
	.sale-dialog {
		border-radius: 10px;
		overflow: hidden;
		box-shadow: 0 12px 40px rgba(15, 35, 52, 0.18);
	}
	.sale-dialog .el-dialog__header {
		padding: 16px 20px 12px;
		border-bottom: 1px solid #ebeef5;
		background: #f7f9fc;
	}
	.sale-dialog .el-dialog__title {
		font-size: 16px;
		font-weight: 600;
		color: #303133;
	}
	.sale-dialog .el-dialog__body {
		padding: 20px 24px;
		color: #606266;
	}
	.sale-dialog .el-dialog__footer {
		padding: 12px 20px 18px;
		border-top: 1px solid #ebeef5;
		background: #fafbfc;
	}
	.sale-dialog-tip {
		text-align: center;
		font-size: 16px;
		line-height: 1.6;
		color: #303133;
		padding: 12px 8px;
	}
	.sale-dialog-tip--warn {
		color: #e6a23c;
	}
</style>
<style scoped="scoped">
	.sale-order-switch {
		height: 100%;
		max-height: calc(100vh - 94px);
		min-height: 0;
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}

	.sale-order-switch >>> .sale-customer-page {
		height: 100%;
		max-height: 100%;
		flex: 1;
		min-height: 0;
	}

	.sale-order-page {
		--sale-primary: #00abfa;
		--sale-text: #303133;
		--sale-muted: #909399;
		--sale-border: #ebeef5;
		--sale-bg: #f7f9fc;
		--sale-radius: 8px;
		color: var(--sale-text);
		height: 100%;
		max-height: calc(100vh - 94px);
		display: flex;
		flex-direction: column;
		min-height: 0;
		overflow: hidden;
		flex: 1;
	}

	.sale-page-header {
		display: flex;
		flex-direction: column;
		gap: 12px;
		margin-bottom: 12px;
		padding: 14px 16px;
		background: #fff;
		border: 1px solid var(--sale-border);
		border-radius: var(--sale-radius);
		flex-shrink: 0;
	}

	.sale-page-header__top {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 16px;
	}

	.sale-page-header__left {
		display: flex;
		align-items: baseline;
		gap: 10px;
		min-width: 0;
	}

	.sale-page-header__actions {
		display: flex;
		align-items: center;
		gap: 10px;
		flex-shrink: 0;
		margin-left: auto;
	}

	.sale-page-title {
		margin: 0;
		font-size: 18px;
		font-weight: 600;
		color: var(--sale-text);
		line-height: 1.3;
		white-space: nowrap;
	}

	.sale-page-desc {
		margin: 0;
		font-size: 13px;
		color: var(--sale-muted);
		line-height: 1.3;
		white-space: nowrap;
	}

	.sale-query-bar {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 12px 20px;
		padding-top: 12px;
		border-top: 1px solid #f0f2f5;
	}

	.sale-query-item {
		display: inline-flex;
		align-items: center;
		gap: 8px;
	}

	.sale-query-item label {
		font-size: 13px;
		color: #606266;
		white-space: nowrap;
	}

	.sale-query-item .el-select {
		width: 150px;
	}

	.sale-query-item--date >>> .el-date-editor {
		width: 340px;
	}

	.sale-query-item--date >>> .el-range-separator {
		width: 24px;
		padding: 0 2px;
		line-height: 24px;
		color: #606266;
	}

	.sale-query-item--date >>> .el-range-input {
		width: 42%;
	}

	.sale-panel {
		background: #fff;
		border: 1px solid var(--sale-border);
		border-radius: var(--sale-radius);
		overflow: hidden;
	}

	.sale-panel--table {
		flex: 1;
		min-height: 0;
		display: flex;
		flex-direction: column;
	}

	.sale-panel__head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 10px 16px;
		background: var(--sale-bg);
		border-bottom: 1px solid var(--sale-border);
		font-size: 14px;
		font-weight: 600;
		color: var(--sale-text);
		flex-shrink: 0;
	}

	.sale-panel__count {
		font-size: 12px;
		font-weight: 400;
		color: var(--sale-muted);
	}

	.table {
		flex: 1;
		min-height: 0;
		position: relative;
		overflow: hidden;
	}

	.table >>> .el-table {
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		height: 100% !important;
	}

	.table >>> .el-table th {
		color: #606266;
		font-weight: 600;
		padding: 10px 0;
		background-color: #f5f7fb;
	}

	.table >>> .el-table th.sale-qty-col .cell {
		white-space: nowrap;
		word-break: keep-all;
	}

	.table >>> .el-table td {
		padding: 8px 0;
		background-color: #fff;
	}

	.table >>> .el-table__body tr:hover > td {
		background-color: #f5f7fa !important;
	}

	.table >>> .el-table td.sale-op-col {
		background-color: #fff !important;
	}

	.table >>> .el-table__body tr:hover > td.sale-op-col {
		background-color: #f5f7fa !important;
	}

	.fenye {
		flex-shrink: 0;
		padding: 10px 16px;
		border-top: 1px solid var(--sale-border);
		background: #fff;
		display: flex;
		justify-content: flex-end;
	}

	.blue {
		color: var(--sale-primary);
		cursor: pointer;
		margin-right: 12px;
	}

	.blue:hover {
		opacity: 0.8;
		text-decoration: underline;
	}

	.sale-op-gap {
		display: inline-block;
	}

	.sale-status {
		color: #e6a23c;
	}

	.input {
		width: 400px;
	}

	@media (max-width: 1280px) {
		.sale-query-item .el-select {
			width: 130px;
		}
		.sale-query-item--date >>> .el-date-editor {
			width: 320px;
		}
	}

	@media (max-width: 768px) {
		.sale-order-switch,
		.sale-order-page {
			height: auto;
			max-height: none;
			overflow: visible;
		}
		.sale-page-header__top {
			flex-direction: column;
			align-items: stretch;
		}
		.sale-page-header__actions {
			justify-content: flex-end;
		}
		.sale-panel--table {
			min-height: 420px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/sale/order.vue